import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import { TransitionProps } from '@mui/material/transitions';
import { InfoOutlined } from '@mui/icons-material';
import lightTheme from '../../theme/light';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
interface Props {
    title: string,
    message: string
    close: () => void
}
const AlertDialogSlide: React.FC<Props> = ({
    title,
    close,
    message
}) => {


    return (
        <React.Fragment>
            <Dialog
                open
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                onClose={close}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 1,
                        maxWidth: 400
                    }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    pt: 3,
                    px: 2
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: 56,
                        width: 56,
                        borderRadius: '50%',
                        bgcolor: lightTheme.palette.primary.contrastText,
                        mb: 1.5
                    }}>
                        <InfoOutlined sx={{ fontSize: 30, color: lightTheme.palette.primary.main }} />
                    </Box>
                    <DialogTitle sx={{ p: 0, fontWeight: 600 }}>{title}</DialogTitle>
                </Box>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-slide-description"
                        sx={{ textAlign: 'center' }}
                    >
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', pb: 2.5 }}>
                    <Button
                        variant={'contained'}
                        onClick={close}
                        sx={{ textTransform: 'none', borderRadius: 2, px: 4 }}
                    >
                        I Understand
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default AlertDialogSlide
